import { CompanyWebhookDeliveryState } from "@freightsimple/generated-hubble-openapi-client/models/CompanyWebhookDeliveryState";
import { CompanyWebhookDeliveryTrigger } from "@freightsimple/generated-hubble-openapi-client/models/CompanyWebhookDeliveryTrigger";
import type { CompanyWebhookDelivery } from "@freightsimple/generated-hubble-openapi-client/models/CompanyWebhookDelivery";
import type { WebhookDeliveriesPage } from "@freightsimple/generated-hubble-openapi-client/models/WebhookDeliveriesPage";
import type { WebhookDeliveryDetail } from "@freightsimple/generated-hubble-openapi-client/models/WebhookDeliveryDetail";
import { asOffsetDateTime } from "@freightsimple/time/branded-types";
import { webhookDeliveryRootId } from "@/Shared/Buttons/WebhookDeliveryRedeliverButton";
import { sampleWebhookDeliveries } from "./publicApiRequestAuditInlineResponses";

// The in-transit send that timed out, as the original of a chain.
const timedOut = sampleWebhookDeliveries[1]!;

// Ops re-sent it and the endpoint took it.
const { errorMessage: _timedOutError, ...timedOutFields } = timedOut;
const opsRedelivery: CompanyWebhookDelivery = {
  ...timedOutFields,
  companyWebhookDeliveryId: "8f2f6b1a-8f2a-4b1e-9b1a-000000000015",
  state: CompanyWebhookDeliveryState.Delivered,
  attemptCount: 1,
  httpStatus: 200,
  responseBody: JSON.stringify({ received: true }),
  deliveredAt: asOffsetDateTime("2026-08-14T16:02:01Z"),
  trigger: CompanyWebhookDeliveryTrigger.Ops,
  triggeredByEmail: "bruno.valenzuela@freightsimple.com",
  retriedFromDeliveryId: timedOut.companyWebhookDeliveryId!,
  createdAt: asOffsetDateTime("2026-08-14T16:02:00Z"),
};

const deliveries = [opsRedelivery, ...sampleWebhookDeliveries];

const page = {
  deliveries,
  totalCount: 147,
  page: 0,
  pageSize: 25,
  retentionDays: 30,
  // What the server works out from the whole chain; on this page every chain is on the page.
  deliveredRootDeliveryIds: [
    ...new Set(
      deliveries
        .filter((d) => d.state === CompanyWebhookDeliveryState.Delivered)
        .map(webhookDeliveryRootId),
    ),
  ],
} satisfies WebhookDeliveriesPage;

const detail = {
  delivery: timedOut,
  attempts: [timedOut, opsRedelivery],
} satisfies WebhookDeliveryDetail;

export const COMPANY_WEBHOOK_DELIVERIES_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown>
> = {
  "/apollo/company-webhooks/list-webhook-deliveries": page,
  "/apollo/company-webhooks/get-webhook-delivery": detail,
};
